import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const IntroductionWrapper = styled('div')`
  background-color: var(--s-color-surface-2);
  margin: ${({ theme }) => `-${theme.x3spacePx}px -${theme.x2spacePx}px
    ${theme.x2spacePx}px -${theme.x2spacePx}px`};
  padding: ${({ theme }) =>
    `${theme.x2spacePx}px ${theme.x2spacePx}px  ${theme.x3spacePx}px  ${theme.x2spacePx}px`};
  ${media.mdUp`
    margin: -${({ theme }) => theme.x4spacePx}px -${({ theme }) =>
      theme.x4spacePx}px ${({ theme }) => theme.x2spacePx}px -${({ theme }) =>
      theme.x4spacePx}px;
    padding: ${({ theme }) => theme.x4spacePx}px ${({ theme }) =>
      theme.x4spacePx}px ${({ theme }) => theme.x3spacePx}px ${({ theme }) =>
      theme.x4spacePx}px;
  `}
  ${media.lgUp`
   border-top-left-radius: 8px;
   border-top-right-radius: 8px;
  `}
`;

export const ContentWrapper = styled('div')`
  background: ${({ theme }) => theme.color.spaceGray};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) =>
    `${theme.x2spacePx - 4}px ${theme.x2spacePx - 4}px ${
      theme.x2spacePx - 4
    }px ${theme.x2spacePx}px`};
  hr {
    margin: ${({ theme }) => theme.x1spacePx}px 0;
  }
  height: min-content;
`;

export const SectionDescription = styled('p')`
  ${({ theme }) => theme.typography.xSmall}
`;

export const Score = styled('div')`
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  p {
    margin: 0;
  }
  span {
    ${({ theme }) => theme.typography.mega}
    color: ${({ theme }) => theme.color.white};
  }
`;

export const SnowflakeWrapper = styled('div')`
  display: none;
  justify-content: center;
  align-items: center;
  ${media.smUp`
    display: flex;
  `}

  > div {
    max-width: 200px;
  }
`;

export const MobileTitleWrapper = styled('div')`
  ${media.smUp`
    display: none;
  `}
`;

export const SnowflakeFallback = styled('div')`
  display: inline-block;
  height: 0;
  padding-bottom: 100%;
  width: 100%;
`;
